// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1mb_M","footerWrapper":"Footer_footerWrapper__1VKqC","logo":"Footer_logo__56My5","sitemap":"Footer_sitemap__3xJTd","contacts":"Footer_contacts__3FCQc"};